import { entryPoint } from "./shared_entry";
import ResLookupPageContainer from "../app/containers/res_lookup_page_container";

entryPoint(ResLookupPageContainer, window.initialState);
